<template>
  <div class="video-article__hot-list">
    <h1 class="header">热门视频</h1>

    <ul class="hot-video-list"  data-spm="hot-feed" v-if="list.length" ref="hotVideoListRef"> 
        <li v-for="item in list" :key="item.id">
            <a class="video-item" :href="item.url" target="_blank">
                <div class="img-box img-do">
                    <div class="cover-layer"></div>
                    <img :src="item.cover && item.cover[0]" alt="">
                    <span class="video-info-tip">{{ item.total }}</span>
                </div>
                <div class="title-box">
                    <p class="title">
                        {{ item.title }}
                    </p>
                </div>
            </a>
        </li>
    </ul>
    <!-- 加载状态 -->
    <div v-if="isLoading" class="more-load loading">
        <a href="javascript:void(0)">加载更多</a>
    </div>
    <div v-if="isFinished" class="more-load">
        已经到底了
    </div>
</div>
</template>

<script>
import { setPicSize } from "@/utils/pic-util"
import Util from "@/_utils/util"
import Str from "@/utils/string"
import { getHotList } from '../request/api'

export default {
  data() {
    return {
        isLoading: false,
        isFinished: false,
        size: 30,
        page: 1,
        list: []
    }
  },
  mounted() {
    this.getData()
    window.addEventListener('scroll', Util.throttle(this.handleScroll, 50), true)
  },
  methods: {
    async getData() {
        try {
            if(this.isLoading)return
            if(this.isFinished)return
            this.isLoading = true
            const p = {
                page: this.page++,
                size: this.size
            }
            let list = await getHotList(p)
            list.forEach((item)=>{
                item = this.formatData(item)
                this.list.push(item)
            })
            if(list.length < this.size) {
                this.isFinished = true
            }
            this.isLoading = false
            this.$nextTick(()=>{
                sohuSpm?.domDidChange({target:'hot-feed'})
            })
        } catch (error) {
            this.isFinished = true
            this.isLoading = false
        }
    },
    formatData (item) {
        item.title = Str.subString(item.title, 24)
        const ratio = 2
        const coverWidth = 230 * ratio
        const coverHeight = 128 * ratio
        item.cover && item.cover[0] && ( item.cover[0] = setPicSize(item.cover[0], coverWidth, coverHeight))
        return item
    },
    handleScroll() {
        if (this.isLoading)return
        if (this.isFinished)return
        const windowHeight = window.innerHeight
        const dom = this.$refs['hotVideoListRef']
        const listToTop = dom.getBoundingClientRect().bottom
        if (listToTop <= windowHeight + 200) {
            this.getData()
        }
    }
    
  },
};
</script>

<style scoped>
</style>
